// extracted by mini-css-extract-plugin
export default {"DependenciesPicker":"DependenciesPicker-module__DependenciesPicker__VkFh3At"};